import * as React from "react";
import { getNetworkCount } from "./helpers";
export function ChainCount({ chains }) {
    return (
        <>{chains && getNetworkCount(chains).toString()} </>
    );
}
